import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _ from 'lodash';
export default (function (_ref) {
  var cloudfrontUrl = _ref.cloudfrontUrl;
  return function (data) {
    var content = _.cloneDeep(data);
    var imageEntityMap = _.pickBy(content && content.entityMap, function (_ref2) {
      var type = _ref2.type;
      return type === 'IMAGE';
    });
    var entityMap = _.pickBy(content && content.entityMap, function (_ref3) {
      var type = _ref3.type;
      return type !== 'IMAGE';
    });
    var imageEntityMapKeys = _.keys(imageEntityMap);
    var blocks = _.map(content && content.blocks, function (block) {
      if (block.type !== 'atomic' && !_.includes(_.map(block.entityRanges, 'key'), imageEntityMapKeys)) {
        return block;
      }
      var newBlock = _objectSpread({}, block);
      var entityMapImageKey = _.find(imageEntityMapKeys, function (item) {
        return _.includes(_.map(newBlock.entityRanges, function (_ref4) {
          var key = _ref4.key;
          return "".concat(key);
        }), item);
      });
      newBlock.entityRanges = _.filter(block.entityRanges, function (_ref5) {
        var key = _ref5.key;
        return key !== entityMapImageKey;
      });
      newBlock.type = 'atomic:image';
      newBlock.data = _objectSpread({}, imageEntityMap[entityMapImageKey] ? imageEntityMap[entityMapImageKey].data : {});
      if (newBlock.data.src) {
        newBlock.data.src = "".concat(cloudfrontUrl).concat((newBlock.data.src || '').replace('/cloudfront', ''));
        newBlock.data.align = newBlock.data.alignment;
        newBlock.data.width = newBlock.data.width && "".concat(newBlock.data.width, "%");
      }
      if (newBlock.data.align === 'center') {
        newBlock.data.style = {
          margin: '0 auto'
        };
      }
      return newBlock;
    });
    return {
      blocks: blocks,
      entityMap: entityMap || {}
    };
  };
});